module.exports = __webpack_public_path__ + "static/gallery_yarra_1_thumb-28962a77e6bf6a62a77be4dd61150977.jpg";